
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { searchCustomer,searchPaymentName,getPaymentInfo,getBaseInfo } from "@/api/customer";
import { getRASearch,createRATable,updateRAState,getRAAllTypes,cancelInvalid } from "@/api/remittance-advices"
import { uploadFiles,deleteFiles,downloadFiles } from "@/utils/uploadALOSS"
import { parseTime } from "@/utils"
import { uploadRAFile,getRAFileList,updateFileRemark,getRAInfo,downloadAdvices,getRAAllStates,putRemark,deleteRAfile,updateRAInfo,getAllocationInfo,getUrlList,getSettlementInfo,postSettlement } from "@/api/remittance-advices"
import { getSalesmanList } from "@/api/inquiry";
import {COMPANY_LIST} from "@/constant";
@Component({
  name: "collectionManagement",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private isShowMore = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public showFileListID = "";
  private fpmxshd = {} as any;
  public showAnnex = false;
  private showCollection = false;
  private showCollectionEdit = false;
  private listLoading = false;
  public AnnexList = [] as any;
  public AnnexSelectRows = [] as any;
  private GuaQiReason = "";
  private showDetail = false;
  private headForm = {
    remitter: "", // 汇款人
    company: "HQ", // 公司
    remittingCountry: "",
    registerType: "",
    voucherNumber: "",
    amountReceived: 0,
    handingFee: 0,
    receiptOfAmountDate: "",
    currency: "USD",
    remark: "",
    DistributableAmount: 0,
    accountPeriod: 0, // 账期
  };
  private guest = {
    customerId: "",
    id: "",
    code: "",
    name: "",
    abbr: "",
    accountPeriod: 0,
    nation: "",
    seller: "",
  };
  private customerList = [] as any;
  private customerList1 = [] as any;
  private FileList = [] as any;
  private list = [
    {
      label: "汇款人",
      prop: "remitter",
      key: "remitter",
      type: "selectToOther",
      value: "",
      placeholder: "请填写汇款人",
      remote: true,
      remote_method: this.getPaymentName,
      clearable: true,
      options: [],
      labelKey: "paymentName",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择汇款人",
          trigger: "change",
        },
      ],
    },
    // {
    //   label: "客户",
    //   prop: "customerId",
    //   key: "customerId",
    //   type: "select",
    //   value: "",
    //   placeholder: "请选择客户",
    //   remote: true,
    //   remote_method: this.getCustomer,
    //   clearable: true,
    //   options: [],
    //   labelKey: "abbreviation",
    //   valueKey: "id",
    // },
    {
      label: "登记类型",
      prop: "registerType",
      key: "registerType",
      type: "select",
      placeholder: "选择类型",
      clearable: true,
      maxlength: 100,
      options: [],
      labelKey: "desc",
      valueKey: "name",
      rules: [
        {
          required: true,
          message: "请选择登记类型",
          trigger: "change",
        },
      ],
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "选择交易公司",
      clearable: true,
      maxlength: 100,
      options: COMPANY_LIST,
      rules: [
        {
          required: true,
          message: "请选择交易公司",
          trigger: "change",
        },
      ],
    },
    {
      label: "汇款国家",
      prop: "remittingCountry",
      key: "remittingCountry",
      type: "input",
      placeholder: "请输入汇款国家",
      clearable: true,
      rules: [
        {
          required: true,
          message: "请填写汇款国家",
          trigger: "change",
        },
      ],
    },
    {
      label: "凭证号码",
      prop: "voucherNumber",
      key: "voucherNumber",
      type: "input",
      placeholder: "请输入凭证号码",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "到账金额",
      prop: "amountReceived",
      key: "amountReceived",
      type: "inputNumber",
      placeholder: "请输入到账金额",
      clearable: true,
      precision: 2,
      rules: [
        {
          required: true,
          message: "请填写到账金额",
          trigger: "change",
        },
      ],
    },
    {
      label: "手续费",
      prop: "handingFee",
      key: "handingFee",
      type: "inputNumber",
      placeholder: "请输入手续费",
      clearable: true,
      precision: 2
    },
    {
      label: "合计可分配金额",
      prop: "DistributableAmount",
      key: "DistributableAmount",
      type: "inputNumber",
      placeholder: "合计可分配金额",
      disabled: true,
      clearable: true,
      readonly: true,
      precision: 2
    },
    {
      label: "到账日期",
      prop: "receiptOfAmountDate",
      key: "receiptOfAmountDate",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd",
      rules: [
        {
          required: true,
          message: "请选择到账日期",
          trigger: "change",
        },
      ],
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      placeholder: "选择币种",
      clearable: true,
      maxlength: 100,
      options: [
        {
          name: "RMB",
          value: "RMB",
        },
        {
          name: "USD",
          value: "USD",
        },
        {
          name: "EURO",
          value: "EURO",
        },
      ],
      rules: [
        {
          required: true,
          message: "请选择币种",
          trigger: "change",
        },
      ],
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "",
      clearable: true,
      maxlength: 512
    },
  ];
  private list1 = [
    {
      label: "汇款人",
      prop: "remitter",
      key: "remitter",
      type: "selectToOther",
      value: "",
      placeholder: "请填写汇款人",
      remote: true,
      remote_method: this.getPaymentName,
      clearable: true,
      options: [],
      labelKey: "paymentName",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择汇款人",
          trigger: "change"
        }
      ]
    },
    // {
    //   label: "客户",
    //   prop: "customerId",
    //   key: "customerId",
    //   type: "select",
    //   value: "",
    //   placeholder: "请选择客户",
    //   remote: true,
    //   remote_method: this.getCustomer,
    //   clearable: true,
    //   options: [],
    //   labelKey: "abbreviation",
    //   valueKey: "id",
    // },
    {
      label: "登记类型",
      prop: "registerType",
      key: "registerType",
      type: "select",
      placeholder: "选择类型",
      clearable: true,
      maxlength: 100,
      options: [],
      labelKey: "desc",
      valueKey: "name",
      rules: [
        {
          required: true,
          message: "请选择登记类型",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "选择交易公司",
      clearable: true,
      maxlength: 100,
      options: [
        COMPANY_LIST
      ],
      rules: [
        {
          required: true,
          message: "请选择交易公司",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "汇款国家",
      prop: "remittingCountry",
      key: "remittingCountry",
      type: "input",
      placeholder: "请输入汇款国家",
      clearable: true,
      rules: [
        {
          required: true,
          message: "请填写汇款国家",
          trigger: "change"
        }
      ]
    },
    {
      label: "凭证号码",
      prop: "voucherNumber",
      key: "voucherNumber",
      type: "input",
      placeholder: "请输入凭证号码",
      clearable: true,
      maxlength: 50
    },
    {
      label: "到账金额",
      prop: "amountReceived",
      key: "amountReceived",
      type: "inputNumber",
      placeholder: "请输入到账金额",
      clearable: true,
      precision: 2,
      rules: [
        {
          required: true,
          message: "请填写到账金额",
          trigger: "change"
        }
      ]
    },
    {
      label: "手续费",
      prop: "handingFee",
      key: "handingFee",
      type: "inputNumber",
      placeholder: "请输入手续费",
      clearable: true,
      precision: 2
    },
    {
      label: "合计可分配金额",
      prop: "DistributableAmount",
      key: "DistributableAmount",
      type: "inputNumber",
      placeholder: "合计可分配金额",
      disabled: true,
      clearable: true,
      readonly: true,
      precision: 2
    },
    {
      label: "到账日期",
      prop: "receiptOfAmountDate",
      key: "receiptOfAmountDate",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd",
      rules: [
        {
          required: true,
          message: "请选择到账日期",
          trigger: "change"
        }
      ]
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      placeholder: "选择币种",
      clearable: true,
      maxlength: 100,
      options: [
        {
          name: "RMB",
          value: "RMB",
        },
        {
          name: "USD",
          value: "USD",
        },
        {
          name: "EURO",
          value: "EURO",
        }
      ],
      rules: [
        {
          required: true,
          message: "请选择币种",
          trigger: "change"
        }
      ]
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "",
      clearable: true,
      maxlength: 512
    },
  ];
  private list2 = [
    {
      label: "汇款人",
      prop: "remitter",
      key: "remitter",
      type: "selectToOther",
      value: "",
      placeholder: "请填写汇款人",
      remote: true,
      remote_method: this.getPaymentName,
      clearable: true,
      options: [],
      labelKey: "paymentName",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择汇款人",
          trigger: "change"
        }
      ],
      disabled: true
    },
    // {
    //   label: "客户",
    //   prop: "customerId",
    //   key: "customerId",
    //   type: "select",
    //   value: "",
    //   placeholder: "请选择客户",
    //   remote: true,
    //   remote_method: this.getCustomer,
    //   clearable: true,
    //   options: [],
    //   labelKey: "abbreviation",
    //   valueKey: "id",
    // },
    {
      label: "登记类型",
      prop: "registerType",
      key: "registerType",
      type: "select",
      placeholder: "选择类型",
      clearable: true,
      maxlength: 100,
      options: [],
      labelKey: "desc",
      valueKey: "name",
      rules: [
        {
          required: true,
          message: "请选择登记类型",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "选择交易公司",
      clearable: true,
      maxlength: 100,
      options: COMPANY_LIST,
      rules: [
        {
          required: true,
          message: "请选择交易公司",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "汇款国家",
      prop: "remittingCountry",
      key: "remittingCountry",
      type: "input",
      placeholder: "请输入汇款国家",
      clearable: true,
      rules: [
        {
          required: true,
          message: "请填写汇款国家",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "凭证号码",
      prop: "voucherNumber",
      key: "voucherNumber",
      type: "input",
      placeholder: "请输入凭证号码",
      clearable: true,
      maxlength: 50,
      disabled: true
    },
    {
      label: "到账金额",
      prop: "amountReceived",
      key: "amountReceived",
      type: "inputNumber",
      placeholder: "请输入到账金额",
      clearable: true,
      precision: 2,
      rules: [
        {
          required: true,
          message: "请填写到账金额",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "手续费",
      prop: "handingFee",
      key: "handingFee",
      type: "inputNumber",
      placeholder: "请输入手续费",
      clearable: true,
      precision: 2,
      disabled: true
    },
    {
      label: "合计可分配金额",
      prop: "DistributableAmount",
      key: "DistributableAmount",
      type: "inputNumber",
      placeholder: "合计可分配金额",
      disabled: true,
      clearable: true,
      readonly: true,
      precision: 2
    },
    {
      label: "到账日期",
      prop: "receiptOfAmountDate",
      key: "receiptOfAmountDate",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd",
      rules: [
        {
          required: true,
          message: "请选择到账日期",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      placeholder: "选择币种",
      clearable: true,
      maxlength: 100,
      options: [
        {
          name: "RMB",
          value: "RMB",
        },
        {
          name: "USD",
          value: "USD",
        },
        {
          name: "EURO",
          value: "EURO",
        }
      ],
      rules: [
        {
          required: true,
          message: "请选择币种",
          trigger: "change"
        }
      ],
      disabled: true
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "",
      clearable: true,
      maxlength: 512,
      disabled: true
    },
  ];
  public FileCol = [
    {
      label: "文件名",
      prop: "filename",
      key: "filename",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      show: true,
      disabled: false,
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "handleDeleteClaim",
        },
        {
          name: "下载",
          code: "",
          click: "handleDownloadClaim",
        },
      ],
      width: 210,
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      key: "uploadTime",
      show: true,
      disabled: false,
    },
    {
      label: "凭证备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
  ];
  public AnnexCol = [
    {
      label: "文件名",
      prop: "filename",
      key: "filename",
      show: true,
      disabled: false,
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      key: "uploadTime",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      show: true,
      disabled: false,
      type: "actions",
      options: [
        {
          name: "下载",
          code: "",
          click: "handleDownloadClaim",
        },
        {
          name: "删除",
          type: "delete",
          code: "",
          click: "handleDeleteRAFiles",
        },
      ],
    },
  ];
  public listParam = {
    code: null,
    customerId: null,
    startTime: null,
    endTime: null,
    sellerId: null,
    status: null,
    time: [],
    time2: [],
  };
  public searchForm = [
    {
      label: "收汇单号",
      prop: "code",
      key: "code",
      type: "input",
      value: "",
      placeholder: "请输入收汇单号",
    },
    {
      label: "到账日期",
      prop: "time",
      key: "time",
      type: "dateTimePicker",
      value: "",
      placeholder: "请选择到账日期",
    },
    {
      label: "客人",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请输入客人简称或编号",
      remote: true,
      remote_method: this.searchCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "状态",
      prop: "state",
      key: "state",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [
        {
          desc: "RMB",
          name: "RMB",
        },
        {
          desc: "USD",
          name: "USD",
        },
        {
          desc: "EURO",
          name: "EURO",
        },
      ],
      resetKey: { label: "desc", value: "name" },
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      type: "select",
      value: "",
      placeholder: "请输入销售员编号或姓名",
      options: [],
      // resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "收汇单号",
      prop: "code",
      key: "code",
      type: "link",
      width: '120',
      show: true,
      disabled: false,
    },
    {
      label: "汇款人名称",
      prop: "remitter",
      key: "remitter",
      show: true,
      disabled: false,
    },
    {
      label: "汇款国家",
      prop: "remittingCountry",
      key: "remittingCountry",
      show: true,
      disabled: false,
    },
    {
      label: "到账金额",
      prop: "amountReceived",
      key: "amountReceived",
      show: true,
      disabled: false,
    },
    {
      label: "可分配金额",
      prop: "allocableAmount",
      key: "allocableAmount",
      usePermission: true,
      show: true,
      disabled: false,
    },
    {
      label: "结算金额",
      prop: "settlementAmount",
      key: "settlementAmount",
      show: true,
      tooltipKey: 'settlementInfo',
      type: 'tooltip',
      width: '120',
      disabled: false,
      account: ['A', 'A_B'],
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      show: true,
      disabled: false,
    },
    {
      label: "到账日期",
      prop: "receiptOfAmountDate",
      key: "receiptOfAmountDate",
      show: true,
      disabled: false,
    },
    {
      label: "客人编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
    },
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
      show: true,
      disabled: false,
      render: (prop, row)=>{
        if (row.pcName && row.pcName.length > 0){
          return `[${row.pcName}]${prop}`
        }
        return prop
      }
    },
    {
      label: "登记类型",
      prop: "type",
      key: "type",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      show: true,
      disabled: false,
    },
    {
      label: "状态",
      prop: "state",
      key: "state",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "已分配金额",
      prop: "actions",
      key: "actions",
      show: true,
      disabled: false,
      show_key: "show1",
      type: "actions",
      options: [
        {
          // allocatedAmount
          type: "popover",
          color: "main-color",
          zy: "fpmxshd",
          name: "查看详情",
          code: "",
          click: "handleClaimDetail",
        },
      ],
    },
    {
      label: "关联IV",
      prop: "associatedIv",
      key: "associatedIv",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "关联PI",
      prop: "associatedPi",
      key: "associatedPi",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "客人账期",
      prop: "customerAccountPeriod",
      key: "customerAccountPeriod",
      show: true,
      disabled: false,
      show_key: "show1",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      show_key: "show1",
      length: 255,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
      account: ['B'],
      length: 255,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "结算",
          code: "",
          click: "handlSettleAnAccount",
          key: "state",
          value: "未分配,部分分配",
        },
        {
          name: "作废",
          code: ["cancel"],
          click: "handleClaim",
          key: "state",
          value: "未分配",
        },
        {
          name: "取消作废",
          code: ['cancel'],
          click: "cancelVoid",
          key: "state",
          value: "已作废"
        },
        {
          name: "编辑",
          code: ['edit'],
          click: "handleEdit",
          key: 'state',
          value: '未分配,部分分配,完成分配'
        },
        {
          name: "管理附件",
          code: ['appendix'],
          click: "handleAnnex",
          key: 'state',
          value: '未分配,部分分配,完成分配'
        },
        {
          name: "单据流",
          code: '',
          click: "gotoDocumentFlow",
        },
      ],
      show: true,
      disabled: false,
      width: 240,
    },
  ] as any;
  private showFileList = false;
  private files: File[] = [];
  private fileClaim: any;
  private Annex_fa_id = "";
  private Annex_id = "";
  private showCNApply = false;
  private CN_FAITEM = {} as any;
  private selectRAID = "";

  private formInline = {
    settlement: 0,
    remark: ''
  };
  private rulesForm = {
    remark: [
      { required: true, message: '请输入备注', trigger: 'blur' },
      { max: 512, message: '长度最长为512个字符', trigger: 'blur' }
    ]
  }


  created() {
    if (this.$route.params.code) {
      this.listParam.code = this.$route.params.code;
      this.searchForm[0].value = this.$route.params.code;
    } else if(this.$route.query.code) {
      this.listParam.code = this.$route.query.code;
      this.searchForm[0].value = this.$route.query.code as any;
    }
    if(this.$route.query.customerID) {
      this.listParam.customerId = this.$route.query.customerID
      this.searchForm[2].value = this.$route.query.customerID as any
    } else if(this.$route.params.customerID) {
      this.listParam.customerId = this.$route.params.customerID
      this.searchForm[2].value = this.$route.params.customerID as any
    }
    this.init();
  }

  activated() {
    if (this.$route.params.code) {
      this.listParam.code = this.$route.params.code;
      this.searchForm[0].value = this.$route.params.code;
    } else if(this.$route.query.code) {
      this.listParam.code = this.$route.query.code;
      this.searchForm[0].value = this.$route.query.code as any;
    }
    if(this.$route.query.customerID) {
      this.listParam.customerId = this.$route.query.customerID
      this.searchForm[2].value = this.$route.query.customerID as any
    } else if(this.$route.params.customerID) {
      this.listParam.customerId = this.$route.params.customerID
      this.searchForm[2].value = this.$route.params.customerID as any
    }
    this.init();
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[5].options = res;
  }

  private addFile(file: File) {
    console.log("把文件添加到files里面了", file);
    this.fileClaim = file;
    this.files.push(file);
  }

  private async handleAnnex(row) {
    this.showAnnex = true;
    this.showFileListID = row.row.id;
    await this.getRAFileList(row.row.id);
  }

  private uploadFuJian() {
    this.$refs["uploadFJ"]["$refs"]["upload-inner"].handleClick();
  }

  private async handleUploadFJ() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    await this.uploadToFuJian(formData);
  }

  private uploadClaimFile() {
    this.$refs["uploadClaimFile"]["$refs"]["upload-inner"].handleClick();
  }

  private uploadLoading = false;
  private async handleUploadClaimFile() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadLoading = true;
    await uploadFiles(this.fileClaim).then(async (res:any) => {
      let fileURL = await downloadFiles(
        res.name,
        res.name.split("/")[1].split("_")[0]
      );
      let newObj = {
        id: null,
        filename: res.name.split("/")[1].split("_")[0],
        uploadTime: parseTime(res.name.split("/")[1].split("_")[1]),
        url: fileURL,
        remark: "",
        old_name: res.name,
      };
      this.FileList.push(newObj);
      this.$notify({
        title: "成功",
        message: "上传成功",
        type: "success",
        duration: 2000,
      });
      this.uploadLoading = false;
    }).catch(err => {
      console.log(err);
      this.uploadLoading = false;
    });
  }

  private changeValueCustermer(e) {
    console.log("客人信息输入框返回值", e);
  }

  private async filesDownload() {
    if (this.AnnexSelectRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "至少选择一条数据",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let ids = this.AnnexSelectRows.map(item => {return item.id})
    const params = ids.map((id) => `fileInfoIds=${id}`).join("&");
    const res:any = await getUrlList(params)
    if(res && res.length > 0) {
      res.map(ex => {
        window.open(ex)
      })
    }
    // 清除选择的select
    (this.$refs.table as any).$refs.table.clearSelection();
  }

  private async deleteFiles() {
    if (this.AnnexSelectRows.length === 0) {
      this.$notify({
        title: "提示",
        message: "至少选择一条数据",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let ids = this.AnnexSelectRows.map((item) => {
      return item.id;
    });
    let params = {
      ids,
    };
    await deleteRAfile(params);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    // 清除选择的select
    // (this.$refs.table as any).$refs.table.clearSelection();
    await this.getRAFileList(this.showFileListID);
  }

  private async changeValueWithForm(e) {
    console.log(e);
    if (e.value && e.key === "remitter") {
      this.headForm.remitter = e.paymentName;
      const res: any = await getPaymentInfo(e.value);
      if (res.id) {
        this.headForm.remittingCountry = res.paymentCompanyCountry;
        await this.getBaseInfo(res.id);
      }
    }
  }

  private async handleDeleteClaim(row) {
    this.$confirm("确定要删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        if (row.row.old_name) {
          const res: any = await deleteFiles(row.row.old_name);
          console.log("删除结果", res);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          if (
            this.FileList.findIndex((e) => e.old_name === row.row.old_name) > -1
          ) {
            this.FileList.splice(
              this.FileList.findIndex((e) => e.old_name === row.row.old_name),
              1
            );
          }
        } else {
        let params = {
          ids: [row.row.id]
        }
        const res:any = await deleteRAfile(params).then(res => {
          console.log('删除结果',res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          if(this.FileList.findIndex(e => e.id === row.row.id) > -1) {
            this.FileList.splice(this.FileList.findIndex(e => e.id === row.row.id),1)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      });
    });
  }

  private async handleDownloadClaim(row) {
    if(row.row.id) {
      let ids = [row.row.id]
      const params = ids.map((id) => `fileInfoIds=${id}`).join("&");
      const res:any = await getUrlList(params)
      if(res && res.length > 0) {
        res.map(ex => {
          window.open(ex)
        })
      }
    } else {
      window.open(row.row.url)
    }
  }

  private async getBaseInfo(id) {
    const res: any = await getBaseInfo(id);
    console.log("通过返回的ID查到的客人信息", res);
    if (res.id) {
      this.guest = Object.assign(this.guest, res);
      this.guest.customerId = res.id;
      if (!res.accountPeriod) {
        this.guest.accountPeriod = 0;
      }
    }
  }

  private changeUpdate(e) {
    if (e.data.key === "amountReceived") {
      this.headForm.DistributableAmount =
        Number(e.data.value ? e.data.value : 0) +
        Number(this.headForm.handingFee as any);
    }
    if (e.data.key === "handingFee") {
      this.headForm.DistributableAmount =
        Number(this.headForm.amountReceived as any) +
        Number(e.data.value ? e.data.value : 0);
    }
  }

  private showSettleAnAccount = false
  private settlementId = ''
  private async handlSettleAnAccount(data) {
    this.settlementId = data.row.id
    await getSettlementInfo(this.settlementId).then((res:any) => {
      this.formInline.settlement = res.settlementAmount;
      this.formInline.remark = res.settlementRemark;
      this.showSettleAnAccount = true;
    }).catch(err => {
      console.log(err);
    })
  }

  private confirmSettlement() {
    (this.$refs['ruleFormSettlement'] as any).validate((valid) => {
      if (valid) {
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('p', null, '结算将导致关联的IV无法编辑分配本收汇单的金额 '),
            h('p', null, '请确认是否操作！')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              let data = {
                remark: this.formInline.remark
              }
              await postSettlement(this.settlementId,data).then(res => {
                this.$notify({
                  title: "成功",
                  message: "结算成功！",
                  type: "success",
                  duration: 2000,
                });
                this.showSettleAnAccount = false;
                instance.confirmButtonLoading = false;
                done();
                this.getList();
              }).catch(err => {
                console.log(err);
                instance.confirmButtonLoading = false;
                done();
              })
            } else {
              done();
            }
          }
        })
      }
    });
  }

  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadToFuJian(formData) {
    await uploadRAFile(this.showFileListID, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    await this.getRAFileList(this.showFileListID);
    // await this.getCNFileList(this.Annex_fa_id);
  }

  private async uploadJieKou(formData) {
    console.log("开始");
    // await uploadCNFile(this.Annex_id,formData);
    // this.$notify({
    //   title: "成功",
    //   message: "上传成功",
    //   type: "success",
    //   duration: 2000
    // });
    // await this.getCNFileList(this.Annex_fa_id);
  }

  private async getRAFileList(id) {
    this.loading = true;
    const res: any = await getRAFileList(id);
    this.AnnexList = res;
    this.loading = false;
  }

  private async handleRemarkFilesCreate(item) {
    if (this.FileList.findIndex((e) => e.id === item.id) > -1) {
      this.FileList[this.FileList.findIndex((e) => e.id === item.id)].remark =
        item.remark;
    }
  }

  private async handleRemarkBaseTable(row) {
    console.log("修改备注", row);
    let data = {
      remark: row.remark,
    };
    await putRemark(row.id, data);
    this.getList();
  }

  private async handleRemarkFiles(item) {
    let data = {
      remark: item.remark,
    };
    await updateFileRemark(item.id, data);
    this.$notify({
      title: "成功",
      message: "修改成功",
      type: "success",
      duration: 2000,
    });
    await this.getRAFileList(this.showFileListID);
    // await this.getCNFileList(this.Annex_fa_id);
  }

  private async handleClaim(row) {
    this.$confirm("确定要作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await updateRAState(row.row.id);
        this.$message({
          type: "success",
          message: "作废成功!",
        });
        this.getList();
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消作废",
        });
      });
  }

  private cancelVoid(row) {
    this.$confirm('确定要取消作废吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then( async () => {
      await cancelInvalid(row.row.id).then(res => {
        this.$message({
          type: 'success',
          message: '取消作废成功!'
        });
        this.getList();
      }).catch(err => {
        console.log(err)
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '取消作废已取消'
      });
    });
  }

  private async createBtn() {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            if (this.guest.customerId === "") {
              this.$notify({
                title: "错误",
                message: "暂未查询到用户信息，请重新输入",
                type: "error",
                duration: 2000,
              });
              return;
            }
            this.$confirm("关联客人后将无法被取消，请谨慎选择", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                this.showCollection = false;
                await createRATable(
                  Object.assign(this.headForm, this.guest, {
                    fileInfos: this.FileList,
                  })
                );
                this.$message({
                  type: "success",
                  message: "创建成功!",
                });
                this.showCollection = false;
                this.showCollectionEdit = false;
                this.initCreateClaim();
                this.getList();
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async createBtnEdit() {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            if (this.guest.customerId === "") {
              this.$notify({
                title: "错误",
                message: "暂未查询到用户信息，请重新输入",
                type: "error",
                duration: 2000,
              });
              return;
            }
            this.$confirm('关联客人后将无法被取消，请谨慎选择', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              this.showCollection = false;
              await updateRAInfo(this.selectRAID,Object.assign(this.headForm, this.guest, {fileInfos:this.FileList})).then(res => {
                this.showCollection = false;
                this.showCollectionEdit = false;
                this.initCreateClaim()
                this.getList();
                this.$message({
                  type: 'success',
                  message: '更新成功!'
                });
              }).catch(err => {
                console.log(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  private async querySearch(data) {
    console.log("data", data);
    if (data.time && data.time.length > 0) {
      data.startTime = data.time[0];
      data.endTime = data.time[1];
    }
    this.table.pageNumber = 1;
    this.listParam = data ? data : {};
    await this.getList();
  }

  // private handleReason(row) {
  //   this.reasonOtherID = row.row.id
  //   this.GuaQiReason = row.row.auditHangReason
  //   this.dialogVisible = true
  // }

  private async getRAAllStates() {
    const res: any = await getRAAllStates();
    this.searchForm[3].options = res;
  }

  private async queryDownload(form) {
    if (form.time.length > 0) {
      form.startTime = form.time[0];
      form.endTime = form.time[1];
    }
    await downloadAdvices(form);
    this.$notify({
      title: "成功",
      message: "下载成功",
      type: "success",
      duration: 2000,
    });
  }

  private init() {
    // this.getSalesmanList();
    this.searchCustomer();
    this.getCustomer();
    this.getCustomer1();
    this.getPaymentName();
    // this.getPiCustomerShipmentStatus();
    // this.getPiDeliveryStatus();
    this.getRAAllTypes();
    this.getList();
    this.getSalesmanList();
    this.getRAAllStates();

    this.getPermission();
  }

  private async getRAAllTypes() {
    const res:any = await getRAAllTypes()
    this.list[1].options = res
    this.list1[1].options = res
    this.list2[1].options = res
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = true;
    const { total, list }: any = await getRASearch(params);
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map((item) => {
      item.amountCan =
        parseInt(item.amountReceived) - parseInt(item.handingFee);
    });
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // private async getSuppliersList(name = "") {
  //   const res: any = await this.getSuppliers(name);
  //   this.searchForm[2].options = res;
  // }

  // private async getSuppliers(name = "") {
  //   const res: any = await getSuppliersList({ abbreviation: name });
  //   return res;
  // }

  private async retrieval() {
    await this.getBaseInfo(this.guest.id);
    if (this.guest.customerId === "") {
      this.$notify({
        title: "错误",
        message: "暂未查询到用户信息，请重新输入",
        type: "error",
        duration: 2000,
      });
    }
  }

  private async handleDeleteRAFiles(row) {
    this.$confirm("确定要删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let params = {
          ids: [row.row.id],
        };
        const res: any = await deleteRAfile(params);
        console.log("删除结果", res);
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        await this.getRAFileList(this.showFileListID);
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
  }

  // 收汇单跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "REMITTANCE_ADVICE", documentId: data.row.id },
    });
  }

  private initCreateClaim() {
    this.headForm = {
      remitter: "", // 汇款人
      company: "HQ", // 公司
      remittingCountry: "",
      registerType: "",
      voucherNumber: "",
      amountReceived: 0,
      handingFee: 0,
      receiptOfAmountDate: "",
      currency: "USD",
      remark: "",
      DistributableAmount: 0,
      accountPeriod: 0, // 账期
    };
    this.guest = {
      customerId: "",
      id: "",
      code: "",
      name: "",
      abbr: "",
      accountPeriod: 0,
      nation: "",
      seller: "",
    };
    this.FileList = [] as any;
  }

  private onSelectionChange(rows) {
    this.AnnexSelectRows = rows;
  }

  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[2].options = res;
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    // this.list[0].options = res;
    console.log(1111);
    this.customerList = res;
    if (res.length === 0) {
      this.guest.id = name;
      this.guest.customerId = "";
    }
  }
  private async getCustomer1(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.customerList1 = res;
  }

  private showCollectionClose() {
    this.FileList.map(async (item) => {
      if (!item.id) {
        if (item.old_name) {
          await deleteFiles(item.old_name);
        }
      }
    });
    this.showCollection = false;
    this.showCollectionEdit = false;
    this.initCreateClaim();
  }

  private async getPaymentName(name = "") {
    const res: any = await searchPaymentName({ keyword: name });
    this.list[0].options = res;
    if (res.length === 0) {
      this.headForm.remitter = name;
    }
  }

  private getPermission() {
    let per = this.$route.meta.buttonCodes.includes('amount')
    let num = this.tableCol.findIndex(e => e.key === 'allocableAmount')
    if(num != -1) {
      if(!per) {
        this.tableCol.splice(num, 1)
      }
    }
  }

  private async linkClick(row) {
    this.selectRAID = row.row.id;
    const res: any = await getRAInfo(row.row.id);
    console.log("编辑的res", res);
    this.FileList = res.fileInfoRes ? res.fileInfoRes : [];
    this.FileList.map((item) => {
      item.filename = item.fileName;
    });
    this.headForm.remitter = res.remitter ? res.remitter : "";
    this.headForm.company = res.company ? res.company : "";
    this.headForm.remittingCountry = res.remittingCountry
      ? res.remittingCountry
      : "";
    this.headForm.registerType = res.type ? res.type : "";
    this.headForm.voucherNumber = res.voucherNumber ? res.voucherNumber : "";
    this.headForm.amountReceived = res.amountReceived ? res.amountReceived : 0;
    this.headForm.handingFee = res.handingFee ? res.handingFee : 0;
    this.headForm.receiptOfAmountDate = res.receiptOfAmountDate
      ? res.receiptOfAmountDate
      : "";
    this.headForm.currency = res.currency ? res.currency : "";
    this.headForm.remark = res.remark ? res.remark : "";
    this.headForm.DistributableAmount =
      (res.amountReceived ? Number(res.amountReceived) : 0) +
      (res.handingFee ? Number(res.handingFee) : 0);
    this.guest.id = res.customerId ? res.customerId : "";
    this.guest.customerId = res.customerId ? res.customerId : "";
    this.guest.code = res.customerCode ? res.customerCode : "";
    this.guest.name = res.customerName ? res.customerName : "";
    this.guest.abbr = res.customerAbbr ? res.customerAbbr : "";
    this.guest.accountPeriod = res.customerAccountPeriod
      ? res.customerAccountPeriod
      : 0;
    this.guest.nation = res.customerNation ? res.customerNation : "";
    this.guest.seller = res.seller ? res.seller : "";
    this.list.map((it) => {
      it.disabled = true;
    });
    this.showDetail = true;
    this.showCollectionEdit = true;
  }

  private async handleEdit(row) {
    this.selectRAID = row.row.id;
    const res: any = await getRAInfo(row.row.id);
    console.log("编辑的res", res);
    this.FileList = res.fileInfoRes ? res.fileInfoRes : [];
    this.FileList.map((item) => {
      item.filename = item.fileName;
    });
    this.headForm.remitter = res.remitter ? res.remitter : "";
    this.headForm.company = res.company ? res.company : "";
    this.headForm.remittingCountry = res.remittingCountry
      ? res.remittingCountry
      : "";
    this.headForm.registerType = res.type ? res.type : "";
    this.headForm.voucherNumber = res.voucherNumber ? res.voucherNumber : "";
    this.headForm.amountReceived = res.amountReceived ? res.amountReceived : 0;
    this.headForm.handingFee = res.handingFee ? res.handingFee : 0;
    this.headForm.receiptOfAmountDate = res.receiptOfAmountDate
      ? res.receiptOfAmountDate
      : "";
    this.headForm.currency = res.currency ? res.currency : "";
    this.headForm.remark = res.remark ? res.remark : "";
    this.headForm.DistributableAmount =
      (res.amountReceived ? Number(res.amountReceived) : 0) +
      (res.handingFee ? Number(res.handingFee) : 0);
    this.guest.id = res.customerId ? res.customerId : "";
    this.guest.customerId = res.customerId ? res.customerId : "";
    this.guest.code = res.customerCode ? res.customerCode : "";
    this.guest.name = res.customerName ? res.customerName : "";
    this.guest.abbr = res.customerAbbr ? res.customerAbbr : "";
    this.guest.accountPeriod = res.customerAccountPeriod
      ? res.customerAccountPeriod
      : 0;
    this.guest.nation = res.customerNation ? res.customerNation : "";
    this.guest.seller = res.seller ? res.seller : "";
    this.list.map((it) => {
      it.disabled = false;
    });
    this.showDetail = false;
    this.showCollectionEdit = true;
  }

  // 导出excel
  private isExporting = false;

  private async handleClaimDetail(row) {
    const res: any = await getAllocationInfo(row.row.id);
    this.fpmxshd = res;
  }

  // 导出
  public async handleExport() {
    console.log(111);
    // await handleExport()
    // this.$notify({
    //   title: "成功",
    //   message: "下载成功",
    //   type: "success",
    //   duration: 2000
    // });
    // console.log('开始')
    // this.isExporting = true;
    // let table = this.tableCol.slice(0, this.tableCol.length - 1);
    // const headers = table.map((v) => v.label);
    // const fieldNames = table.map((v) => v.key);
    // let list = deepClone(this.table.list);
    // list.forEach((v) => {
    //   v.shipmentStatus = this.searchForm[7].options.find(
    //     (item) => item.id === v.shipmentStatus
    //   ).name;
    //   v.status = this.searchForm[6].options.find(
    //     (item) => item.id === v.status
    //   ).name;
    // });
    // exportJson2Excel(
    //   headers,
    //   formatJson(fieldNames, list),
    //   `PI管理-${new Date()}`
    // );
    // this.isExporting = false;
  }
}
